import classNames from 'classnames';
import { ChevronRight } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../Shared/UI/Icon';
import Container from './Container';

export default function RegistrationProgress({
  step,
}: {
  step: 'create_account' | 'create_charity'
}) {
  const { t } = useTranslation();

  return (
    <div className="pb-8 -mb-16 border-b bg-slate-150 border-b-slate-200">
      <Container className="pt-8">
        <div className="flex items-center justify-center">
          <div className="flex items-center">
            <span className={classNames('rounded-full mr-2 w-6 h-6 flex items-center justify-center font-medium text-xs', step === 'create_account' ? 'bg-emerald-200 text-emerald-800' : 'bg-slate-200 text-slate-500')}>
              1
            </span>
            <span className={classNames('font-medium text-sm leading-tight', step === 'create_account' ? 'text-slate-800' : 'text-slate-500')}>
              {t('backend:create_account')}
            </span>
          </div>
          <Icon className="mx-2 text-slate-400">
            <ChevronRight />
          </Icon>
          <div className="flex items-center">
            <span className={classNames('rounded-full mr-2 w-6 h-6 flex items-center justify-center font-medium text-xs', step === 'create_charity' ? 'bg-emerald-200 text-emerald-800' : 'bg-slate-200 text-slate-500')}>
              2
            </span>
            <span className={classNames('font-medium text-sm leading-tight ', step === 'create_charity' ? 'text-slate-800' : 'text-slate-500')}>
              {t('backend:create_charity')}
            </span>
          </div>
        </div>
      </Container>
    </div>
  );
}
